import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SITE_CONFIG, formatTitle } from '../seo/seoConfig';

function SEO({ title, description, path = '' }) {
  const pageTitle = title ? formatTitle(title) : SITE_CONFIG.defaultTitle;
  const pageDescription = description || SITE_CONFIG.defaultDescription;
  const canonicalUrl = path ? `${SITE_CONFIG.siteUrl}${path}` : SITE_CONFIG.siteUrl;

  return (
    <Helmet>
      <html lang="fr" />
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
}

export default SEO;
